import React from "react";
import {FormattedMessage} from "react-intl";
import classes from "./styles.module.css";

const Empty = () => {
    return (
        <tr className={classes.EmptyRow}>
            <td colSpan="6">
                <div className={classes.Empty}>
                    <h5>
                        <FormattedMessage id="ProjectsWidget.empty.title" defaultMessage="Нет активных проектов"/>
                    </h5>
                </div>
            </td>
        </tr>
    );
};

export default Empty;



// WEBPACK FOOTER //
// ./src/Components/ProjectsWidget/Empty.js